const STORAGE_KEY = 'conv-search-rate-limit';

interface RateLimitEntry {
    expiresAt: number;
}

function hasLocalStorage(): boolean {
    return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

export function setRateLimit(expiresAt: number): void {
    if (!hasLocalStorage()) return;
    const entry: RateLimitEntry = { expiresAt };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entry));
}

export function getRateLimit(): RateLimitEntry | null {
    if (!hasLocalStorage()) return null;
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    try {
        return JSON.parse(raw) as RateLimitEntry;
    } catch {
        localStorage.removeItem(STORAGE_KEY);
        return null;
    }
}

export function clearRateLimit(): void {
    if (!hasLocalStorage()) return;
    localStorage.removeItem(STORAGE_KEY);
}

export function isRateLimited(): boolean {
    const entry = getRateLimit();
    if (!entry) return false;

    if (entry.expiresAt <= Date.now()) {
        clearRateLimit();
        return false;
    }

    return true;
}
